import { CanvasService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { canvasKeys } from 'app/queries/canvas/canvasKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof canvasKeys.courseStudentsByCourse>>;

export const createFetchCanvasCourseStudentsQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ courseId }], signal }: TParams) =>
    call(() => cancelOnSignal(CanvasService.getCourseStudents({ courseId }), signal));
